"use client";

import { c as _c } from "react/compiler-runtime";
import type { FragmentOfShopifyStorefront } from "@repo/graphql-shopify-storefront";
import { useMediaQuery } from "@react-hookz/web";
import { type CSSProperties, useEffect, useState } from "react";
import { readFragmentShopifyStorefront } from "@repo/graphql-shopify-storefront";
import { breakpoints, type ClassValue, cn } from "@repo/lib";
import { GenericPage_Article_Fragment } from "./graphql";
export function Article(t0) {
  const $ = _c(35);
  const {
    children,
    className,
    pageMasked
  } = t0;
  const page = readFragmentShopifyStorefront(GenericPage_Article_Fragment, pageMasked);
  const t1 = useMediaQuery(`only screen and (min-width : ${breakpoints?.sm?.min?.toString() ?? "0"})`);
  const t2 = useMediaQuery(`only screen and (min-width : ${breakpoints?.md?.min?.toString() ?? "0"})`);
  const t3 = useMediaQuery(`only screen and (min-width : ${breakpoints?.lg?.min?.toString() ?? "0"})`);
  const t4 = useMediaQuery(`only screen and (min-width : ${breakpoints?.xl?.min?.toString() ?? "0"})`);
  const t5 = useMediaQuery(`only screen and (min-width : ${breakpoints?.["2xl"]?.min?.toString() ?? "0"})`);
  let t6;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== t5) {
    t6 = {
      sm: t1,
      md: t2,
      lg: t3,
      xl: t4,
      "2xl": t5
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const mediaQueries = t6;
  const [style, setStyle] = useState(page?.style?.value ? JSON.parse(page?.style?.value ?? "") as CSSProperties : {});
  let t7;
  if ($[6] !== mediaQueries.lg || $[7] !== mediaQueries.md || $[8] !== mediaQueries.sm || $[9] !== mediaQueries.xl || $[10] !== page?.style?.value || $[11] !== page?.styleLg?.value || $[12] !== page?.styleMd?.value || $[13] !== page?.styleSm?.value || $[14] !== page?.styleXl?.value) {
    t7 = () => {
      const stylesToMerge = [page?.style?.value, mediaQueries.sm && page?.styleSm?.value, mediaQueries.md && page?.styleMd?.value, mediaQueries.lg && page?.styleLg?.value, mediaQueries.xl && page?.styleXl?.value].filter(Boolean).map(_temp);
      setStyle(Object.assign({}, ...stylesToMerge));
    };
    $[6] = mediaQueries.lg;
    $[7] = mediaQueries.md;
    $[8] = mediaQueries.sm;
    $[9] = mediaQueries.xl;
    $[10] = page?.style?.value;
    $[11] = page?.styleLg?.value;
    $[12] = page?.styleMd?.value;
    $[13] = page?.styleSm?.value;
    $[14] = page?.styleXl?.value;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = page?.style?.value;
  const t9 = page?.styleSm?.value;
  const t10 = page?.styleMd?.value;
  const t11 = page?.styleLg?.value;
  const t12 = page?.styleXl?.value;
  let t13;
  if ($[16] !== mediaQueries.lg || $[17] !== mediaQueries.md || $[18] !== mediaQueries.sm || $[19] !== mediaQueries.xl || $[20] !== t10 || $[21] !== t11 || $[22] !== t12 || $[23] !== t8 || $[24] !== t9) {
    t13 = [mediaQueries.sm, mediaQueries.md, mediaQueries.lg, mediaQueries.xl, t8, t9, t10, t11, t12, setStyle];
    $[16] = mediaQueries.lg;
    $[17] = mediaQueries.md;
    $[18] = mediaQueries.sm;
    $[19] = mediaQueries.xl;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
    $[23] = t8;
    $[24] = t9;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  useEffect(t7, t13);
  let t14;
  if ($[26] !== page) {
    t14 = page?.classes?.value && JSON.parse(page.classes.value) as ClassValue;
    $[26] = page;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== className || $[29] !== t14) {
    t15 = cn("grid snap-y snap-start", t14, className);
    $[28] = className;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== children || $[32] !== style || $[33] !== t15) {
    t16 = <article className={t15} style={style}>{children}</article>;
    $[31] = children;
    $[32] = style;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  return t16;
}
function _temp(s) {
  return JSON.parse(s as string) as CSSProperties;
}